export const LADE_VORGANG = "ladeVorgang";
export const UPDATE_VORGANG = "updateVorgang";
export const STARTE_KONSTRUKTION= "starteKonstruktion";
export const BEENDE_KONSTRUKTION= "beendeKonstruktion";
export const STARTE_FERTIGUNG = "starteFertigung";
export const BEENDE_FERTIGUNG= "beendeFertigung";
export const KALKULATION_SPEICHERN= "kalkulationSpeichern";
export const RESET = "reset";

